import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/index/page-title.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-523cb06e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "index"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "bg"
  }, null, -1);
});
var _hoisted_3 = {
  "class": "head"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "GLP-1百科"
  }, null, -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h5", null, "GLP-1百科全书，权威解答触手可及", -1);
});
var _hoisted_6 = {
  "class": "search"
};
var _hoisted_7 = {
  "class": "mb50"
};
var _hoisted_8 = {
  "class": "header-default"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "专家答疑", -1);
});
var _hoisted_10 = {
  "class": "mb50"
};
var _hoisted_11 = {
  "class": "header-default"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "用药指导", -1);
});
var _hoisted_13 = {
  "class": "mb50"
};
var _hoisted_14 = {
  "class": "header-default"
};
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "临床指南", -1);
});
var _hoisted_16 = {
  "class": "clinical-guideline"
};
var _hoisted_17 = ["onClick"];
var _hoisted_18 = {
  "class": "content"
};
var _hoisted_19 = {
  "class": "title"
};
var _hoisted_20 = {
  "class": "author"
};
var _hoisted_21 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Nav = _resolveComponent("Nav");
  var _component_router_link = _resolveComponent("router-link");
  var _component_ExpertAnswer = _resolveComponent("ExpertAnswer");
  var _component_MedicationGuidance = _resolveComponent("MedicationGuidance");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入你想查找的关键词例如：司美格鲁肽",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.searchText = $event;
    }),
    onKeyup: _cache[1] || (_cache[1] = _withKeys(function () {
      return $options.search && $options.search.apply($options, arguments);
    }, ["enter"]))
  }, null, 544), [[_vModelText, $data.searchText]]), _createElementVNode("span", {
    "class": "cursor-pointer",
    onClick: _cache[2] || (_cache[2] = function () {
      return $options.search && $options.search.apply($options, arguments);
    })
  }, "搜索")])]), _createVNode(_component_Nav, {
    "class": "mb50"
  }), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_router_link, {
    "class": "router-link",
    to: "/expertAnswer"
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode("查看更多>>")];
    }),
    _: 1
  })]), _createVNode(_component_ExpertAnswer)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_router_link, {
    "class": "router-link",
    to: "/medicationGuidance"
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode("查看更多>>")];
    }),
    _: 1
  })]), _createVNode(_component_MedicationGuidance)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createVNode(_component_router_link, {
    "class": "router-link",
    to: "/clinicalGuideline"
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode("查看更多>>")];
    }),
    _: 1
  })]), $data.loaded ? (_openBlock(), _createBlock(_component_el_skeleton, {
    key: 0,
    rows: 3,
    animated: ""
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.clinicalGuidelineList, function (item, index) {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onClick: function onClick($event) {
        return $options.redirectUrl(item.id);
      }
    }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("h5", _hoisted_19, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_20, [_createElementVNode("span", null, _toDisplayString(item.description), 1), item.otherParameter ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(item.otherParameter.releaseDay) + "发布", 1)) : _createCommentVNode("", true)])])], 8, _hoisted_17);
  }), 128))])])])]);
}